import { api } from "@/lib/api";
import ENV from "@/utils/env";

/**
 * requestDemo api
 *
 * Sends a request to book a demo for the specified demo type, message is
 * sent to a teams channel for follow-up in the backend.
 *
 * note: no need for react-query here as we don't need to cache the response
 *
 * @param demoType - The type of demo to request (e.g., "memoryEmotion").
 * @returns A promise that resolves with the response data.
 */
export const requestDemo = async (demoType: string) => {
  const resp = await api.post(`${ENV.API_PLATFORM_URL}/manage/accounts/book-demo`, {
    demoType,
  });
  return resp.data;
};
